import type { ChartDataProviderProps } from '@mui/x-charts-pro';

import { useTheme } from '@mui/material/styles';
import {
  ChartDataProvider,
  ChartsAxisHighlight,
  ChartsLegend,
  ChartsSurface,
  ChartsTooltip,
  ChartsXAxis,
  ChartsYAxis,
  LinePlot,
  MarkPlot,
} from '@mui/x-charts-pro';

import { CHART_AXIS_STYLES, CHART_SERIES_COLORS } from '#utils/charts.ts';

export function ViewChart(props: Pick<ChartDataProviderProps, 'dataset' | 'series' | 'xAxis'>) {
  const theme = useTheme();

  return (
    <ChartDataProvider
      colors={(mode) => CHART_SERIES_COLORS[mode]}
      // Need to set right margin to fit x-axis tick label
      margin={{ right: 30 }}
      yAxis={[{ label: 'Number of Forms' }]}
      {...props}
    >
      <ChartsLegend
        sx={{
          justifyContent: 'center',
          '.MuiChartsLegend-label': {
            color: theme.palette.muted[4],
          },
        }}
      />
      <ChartsSurface>
        <ChartsXAxis sx={CHART_AXIS_STYLES(theme)} />
        <ChartsYAxis sx={CHART_AXIS_STYLES(theme)} />
        <LinePlot />
        <MarkPlot />
        <ChartsAxisHighlight x="line" y="none" />
        <ChartsTooltip />
      </ChartsSurface>
    </ChartDataProvider>
  );
}
